/**
 * Header Scroll Behavior
 */
export function initScrollHeader() {
	let lastScrollY = window.scrollY || window.pageYOffset;
	let ticking = false;
	let resizeTicking = false;
	const logoWidthScrolled = '137px';
	const logoWidthDefault = '200px';
	const header = document.getElementById('masthead');
	const root = document.documentElement;
	
	if (!header) {
		console.warn('Header element (masthead) nicht gefunden');
		return;
	}
	
	function updateHeaderHeight() {
		if (!header) return;
		const headerHeight = header.offsetHeight;
		root.style.setProperty('--header-height', `${headerHeight}px`);
		resizeTicking = false;
	}
	
	function updateLogoWidth() {
		const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
		const isDesktop = viewportWidth >= 768;
		const scrollY = window.scrollY || window.pageYOffset || 0;
		
		// Nur ab 768px die Logo-Breite dynamisch ändern
		if (isDesktop) {
			if (scrollY > 0) {
				root.style.setProperty('--header-logo-width', logoWidthScrolled);
			} else {
				root.style.setProperty('--header-logo-width', logoWidthDefault);
			}
		} else {
			// Mobile: konstant 137px
			root.style.setProperty('--header-logo-width', logoWidthScrolled);
		}
		
		lastScrollY = scrollY;
		ticking = false;
	}
	
	function onScroll() {
		if (!ticking) {
			window.requestAnimationFrame(updateLogoWidth);
			ticking = true;
		}
	}
	
	function onResize() {
		if (!resizeTicking) {
			window.requestAnimationFrame(() => {
				updateHeaderHeight();
				updateLogoWidth();
			});
			resizeTicking = true;
		}
	}
	
	function initialize() {
		updateHeaderHeight();
		setTimeout(() => {
			const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
			const isDesktop = viewportWidth >= 768;
			const initialScrollY = Math.max(0, window.scrollY || window.pageYOffset || 0);
			
			// Nur ab 768px die Logo-Breite dynamisch ändern
			if (isDesktop) {
				if (initialScrollY > 0) {
					root.style.setProperty('--header-logo-width', logoWidthScrolled);
				} else {
					root.style.setProperty('--header-logo-width', logoWidthDefault);
				}
			} else {
				// Mobile: konstant 137px
				root.style.setProperty('--header-logo-width', logoWidthScrolled);
			}
			lastScrollY = initialScrollY;
		}, 100);
	}
	
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initialize);
	} else {
		initialize();
	}
	
	window.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('resize', onResize, { passive: true });

	if (window.MutationObserver) {
		const observer = new MutationObserver(() => {
			updateHeaderHeight();
		});
		observer.observe(header, {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ['class', 'style']
		});
	}
}

